import { z } from 'zod';

export const ConsumerNotificationListItemSchema = z.object({
  id: z.uuid(),
  type: z.enum([
    'CHAT_MESSAGE',
    'RECEPTION_CHECKLIST_PENDING',
    'RECEPTION_CHECKLIST_APPROVED',
    'RECEPTION_CHECKLIST_REJECTED',
    'SERVICE_ORDER_CREATED',
    'SERVICE_ORDER_STATUS_CHANGED',
    'SERVICE_QUOTE_SENT',
    'SERVICE_ORDER_ITEM_DECISION',
    'SERVICE_QUOTE_ITEM_DECISION',
    'SERVICE_ORDER_ITEM_ADDED',
    'SERVICE_ORDER_ITEM_EXECUTION_CHANGED',
    'CHECKOUT_CHECKLIST_PENDING',
    'CHECKOUT_CHECKLIST_APPROVED',
    'CHECKOUT_CHECKLIST_REJECTED',
    'APPOINTMENT_REMINDER_D1',
    'APPOINTMENT_REMINDER_T1H',
    'APPOINTMENT_CONFIRMED',
    'APPOINTMENT_CANCELLED',
    'APPOINTMENT_RESCHEDULED',
    'PLACE_CAMPAIGN',
    'BIRTHDAY',
    'BIRTHDAY_COLLECTION',
    'MILEAGE_UPDATE',
    'NPS_SURVEY',
    'PICKUP_READY',
    'REVISION_REMINDER',
    'MAINTENANCE_ALERT',
    'WORK_TIMER_CLOSING_MECHANIC',
    'WORK_TIMER_CLOSING_SUMMARY',
  ]),
  title: z.string().min(1),
  body: z.string().min(1),
  deeplink: z.string().min(1),
  tenantId: z.uuid().nullable(),
  readAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
});

export const ConsumerNotificationsResponseSchema = z.object({
  items: z.array(ConsumerNotificationListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int().positive(),
  }),
});

export const ConsumerUnreadNotificationsResponseSchema = z.object({
  unreadCount: z.number().int().nonnegative(),
});

export const RegisterDeviceTokenBodySchema = z.object({
  expoPushToken: z.string().min(1).max(512),
  platform: z.enum(['ios', 'android', 'web']),
});

export const RegisterDeviceTokenResponseSchema = z.object({
  ok: z.literal(true),
});

export const MarkNotificationReadResponseSchema = z.object({
  ok: z.literal(true),
});

export const DismissNotificationResponseSchema = z.object({
  ok: z.literal(true),
});

export type ConsumerNotificationListItem = z.infer<typeof ConsumerNotificationListItemSchema>;
export type ConsumerNotificationsResponse = z.infer<typeof ConsumerNotificationsResponseSchema>;
export type ConsumerUnreadNotificationsResponse = z.infer<
  typeof ConsumerUnreadNotificationsResponseSchema
>;
export type RegisterDeviceTokenBody = z.infer<typeof RegisterDeviceTokenBodySchema>;
export type RegisterDeviceTokenResponse = z.infer<typeof RegisterDeviceTokenResponseSchema>;
export type MarkNotificationReadResponse = z.infer<typeof MarkNotificationReadResponseSchema>;
export type DismissNotificationResponse = z.infer<typeof DismissNotificationResponseSchema>;
